import React, { useState, useEffect } from 'react';
import './CompletedDateModal.css';

const CompletedDateModal = ({ isOpen, onClose, onSave }) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // 1-12
  const currentYear = currentDate.getFullYear();

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  // Reset to current month/year when modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedMonth(currentMonth);
      setSelectedYear(currentYear);
    }
  }, [isOpen, currentMonth, currentYear]);

  const months = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
  ];

  // Generate years: from 1900 to current year (no future years)
  const years = [];
  const startYear = 1900;
  for (let i = currentYear; i >= startYear; i--) {
    years.push(i);
  }

  const handleSave = () => {
    if (selectedMonth && selectedYear) {
      // Format as YYYY-MM with zero-padded month
      const formattedDate = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`;
      onSave(formattedDate);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="completed-date-modal-overlay" onClick={handleCancel}>
      <div className="completed-date-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>When was this completed?</h2>
          <button className="modal-close-btn" onClick={handleCancel}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-content">
          <div className="form-row">
            <div className="form-section">
              <label className="form-label">Month</label>
              <select
                className="form-select"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-section">
              <label className="form-label">Year</label>
              <select
                className="form-select"
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletedDateModal;
